// extracted by mini-css-extract-plugin
export var pillWrapper = "_n4-0";
export var showOverflow = "_n4-1";